import React from "react";
import Icon01 from './images/services/hti-pdt1.png'
import Icon02 from './images/services/hti-pdt2.png'
import Icon03 from './images/services/hti-pdt3.png'
import Icon04 from './images/services/hti-pdt4.png'
import Icon05 from './images/services/hti-pdt5.png'
import Icon06 from './images/services/hti-pdt6.png'
function CustomerInfo() {
    const softwareItems = [
  {
    title: 'Task Management Software',
    icon: Icon01,
    color: '#A7F3D0', // light green
    link:'/task-management'
  },
  {
    title: 'Recruitment Software',
    icon: Icon02,
    color: '#BFDBFE', // light blue
    link: '/recruitment-software'
  },
  {
    title: 'HR Management Tool',
    icon: Icon03,
    color: '#FBCFE8', // light pink
    link:'/HR-Management-Tool'
  },
  {
    title: 'AI Customer Support Agents',
    icon: Icon04,
    color: '#E9D5FF', // lavender
    link: '/AI-Powered-Customer-Support'
  },
  {
    title: 'Facility & Asset Management Software',
    icon: Icon05,
    color: '#FEF9C3', // pale yellow
    link: '/facility-asset-management'
  },
  {
    title: 'CRM Tool',
    icon: Icon06,
    color: '#BAE6FD', // pale blue
    link:'/crm-tool'
  },
];

  return (
    <section className="image-description-section section align-item-start" style={{alignItems:"start"}}>
       
    <div className="image-description-left image-section-left">
        <span className="our-pdt-head">Our Products</span>
       <p className="hti-pdt-text">
        HTI has developed several business software applications that enhance our services & solutions for our customers.
        <br/>Our products include:</p>
    </div>
    <div className="image-description-right description">
        <div className="software-grid">
      {softwareItems.map((item, index) => (
        
          <a href={item.link} key={index} className="software-card" style={{ textDecoration: 'none' }}>
          <div
            className="software-icon"
            
          >
          <img src={item.icon} alt={item.title} />
          </div>
          <div className="software-title">{item.title}</div>
        </a>
      ))}
    </div>
    </div>
</section>  
  )
}
export default CustomerInfo;